import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=a0deae6a&scoped=true&"
import script from "./Secondary.vue?vue&type=script&lang=js&"
export * from "./Secondary.vue?vue&type=script&lang=js&"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=a0deae6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0deae6a",
  null
  
)

export default component.exports